module.exports = __webpack_public_path__ + "static/media/04_hero_desktop.b64964cc.jpg";